import { useContext } from "react"
import { WebBootContext } from "source/publishing/WebBoot"

/**
 * Return the appropriate home page based on the current session's draft mode
 */
export function useHomePageForSession() {
  const { draftMode, publishedHomePage, draftHomePage } =
    useContext(WebBootContext)
  return draftMode ? draftHomePage : publishedHomePage
}
